import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import SearchFilterComp from "../../components/shared/SearchFilterComp";
import TabComp from "../../components/shared/TabComp";
import TableComp from "../../components/shared/table/TableComp";
import useAppGlobal from "../../context/useAppGlobal";
import { manufacturerList } from "../../Mocks/SelectSearch.mock";
import ManufactureCreate from "./ManufactureCreate";
import useManufacturerAction from "./utils/useManufacturerAction";
import useManufacturerBody from "./utils/useManufacturerBody";
import useManufacturerHeader from "./utils/useManufacturerHeader";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function ManufacturerTable() {
  const permisisonCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog } = useAppGlobal();
  const header = useManufacturerHeader();
  const action = useManufacturerAction();
  const [sumWhouseId, setSumWHouseId] = useState();
  const [manuKeyword, setManuKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const { bodyList, sortData, setPagi, pagi, error, total } = useManufacturerBody({
    searchBy,
    manuKeyword,
    manufacturerList,
  });

  const handleOpenCreateManu = () => {
    handleOpenDialog({
      content: <ManufactureCreate />,
      size: "md",
      title: "Tạo nhà sản xuất",
    });
  };

  return (
    <>
      <PageHeader
        name="Quản lý Sản phẩm"
        subName="Nhà Sản Xuất"
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
      <Stack
        gap={1.5}
        mb={1.5}
      >
        <Button
          disabled={!permisisonCheck([PERMISSIONS.CREATE_MANUFACTURER])}
          onClick={handleOpenCreateManu}
          variant="contained"
          startIcon={<Add />}
          sx={{ width: "220px", mt: "12px" }}
        >
          Thêm Nhà sản xuất
        </Button>
        <Typography sx={{ fontWeight: "bold" }}>{total < 10 ? "0" + total : total} nhà sản xuất</Typography>
        <TabComp tabs={[{ id: "manufacturer", name: "Nhà sản xuất" }]} />
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
        >
          <SearchFilterComp
            selectList={manufacturerList}
            getSearchKeyword={setManuKeyword}
            getSelectKeyword={setSearchBy}
          />
        </Box>
      </Stack>
      <TableComp
        total={total}
        pagi={pagi}
        setPagi={setPagi}
        headers={header}
        bodyList={bodyList}
        sortData={sortData}
        action={action}
        error={error}
      />
    </>
  );
}
